import { useCallback } from 'react';
import { getLast } from '~/_shared/utils/array/array.helpers';
import { isModalTypeWithProps } from '~/modal/isModalTypeWithProps';
import type { ModalName } from '~/modal/modalRegistry.type';
import type { ModalType } from '~/modal/modalType.enum';
import { useModalStackSelector } from '~/store/modal/modal.selectors';

export const useCheckModalOpen = () => {
  const modalStack = useModalStackSelector();

  const isModalOfTypeOpen = useCallback((modalType: ModalType|ModalName) => {
    const modalInfo = getLast(modalStack);
    if (!modalInfo) {
      return false;
    }
    if (isModalTypeWithProps(modalInfo.typeWithArgs)) {
      return modalInfo.typeWithArgs.modalType === modalType;
    }
    return modalInfo?.typeWithArgs[0] === modalType;
  }, [modalStack]);

  return {
    isModalOfTypeOpen,
  };
};
